import './components/app-root.ts';
import './components/library/toast/toast-container.ts';
import { ToastService } from './services/toast.ts';

// Force service inclusion to prevent tree-shaking
(window as any).__toast = ToastService.getInstance();

const app = document.querySelector<HTMLDivElement>('#app')!;
app.innerHTML = `<app-root></app-root>`;

if (!document.querySelector('toast-container')) {
  const container = document.createElement('toast-container');
  document.body.appendChild(container);
  console.log('[CRATE] Toast container appended to body');
} else {
  console.log('[CRATE] Toast container already exists');
}

console.log('%c [CRATE] Build v6.0.3 - Aesthetic Modular Shell ', 'background: #f59e0b; color: #000; font-weight: bold; padding: 4px; border-radius: 4px;');

